<script lang="ts" setup>
  import ViewTitle from '@/elements/ViewTitle.vue'
  import FeatureFlagTable from '@/components/titrop-settings/FeatureFlagTable.vue'
  import { useFeatureFlags } from '@/composables/useFeatureFlag.ts'
  import PasswordComplexityForm from '@/components/titrop-settings/PasswordComplexityForm.vue'

  import Tabs from 'primevue/tabs'
  import TabList from 'primevue/tablist'
  import TabPanels from 'primevue/tabpanels'
  import TabPanel from 'primevue/tabpanel'

  const featureFlags = useFeatureFlags()
</script>

<template>
  <ViewTitle title="Titrop-Einstellungen" />

  <Tabs value="0" scrollable>
    <TabList>
      <Tab value="0">Feature Flags</Tab>
      <Tab value="1" :disabled="!featureFlags.isEnabled('password_complexity')">Passwortkomplexität</Tab>
    </TabList>
    <TabPanels>
      <TabPanel value="0">
        <FeatureFlagTable />
      </TabPanel>
      <TabPanel value="1">
        <PasswordComplexityForm />
      </TabPanel>
    </TabPanels>
  </Tabs>
</template>

<style scoped>
  .p-tablist {
    @apply border border-b-0 border-gray-300 rounded-tl-lg rounded-tr-lg
  }

  .p-tabpanels {
    @apply border border-gray-300 rounded-bl-lg rounded-br-lg shadow-sm;
  }
</style>
